import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { base_url, CRYPTO_SECRET_KEY,PMS_ADMIN, PRINCIPAL_INVESTIGATOR, QUALITY_REVIEWER, MARKETING_HEAD, MARKETING_STAFF, MEDICAL_REVIEWER } from "./../utilities";
import CryptoJS from "crypto-js";
import axios from "axios";
import axios1 from "../axios-interceptor";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getMSDropdowns } from '../Redux/actions/actions';
import { ForgotPassword } from "./ForgotPassword";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";


const LoginPage = () => {
 const dispatch = useDispatch()
 const loginDetails = useSelector((state) => state.loginData);
 const [showPassword, setShowPassword] = useState(false);


  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }

  useEffect(() => {
    disableBackButton(); 
       
  }, [dispatch]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [termsChecked, setTermsChecked] = useState(false);

  let hashedpassword = CryptoJS.AES.encrypt(
    password,
    CRYPTO_SECRET_KEY
  ).toString();
 
  const navigate = useNavigate();




  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleTermsCheckedChange = (event) => {
    setTermsChecked(event.target.checked);
  };
  const isSignInEnabled = email && password && termsChecked;
const [errorMessage, setErrorMessage] = useState('')
const [modalShow, setModalShow] = React.useState(false);


const handleForgotPwd=()=>{
  setModalShow(true)
}

  const handleLogin = () => {

    axios
      .post(base_url + "sessions/login", {
        email: email,
        password: hashedpassword,
      })
      .then((res) => {
        if (res.status == 200) {
          let result = res.data.result
          
          let message = res.data.message;
          if (message !== "login success") {
            
            setErrorMessage(message);
          }else{
            localStorage.setItem("pwdid", hashedpassword)
            localStorage.setItem('role_code', result.role_code)
            localStorage.setItem("login_user_name", result.name);
            localStorage.setItem("login_user_id", result.user_id);
            localStorage.setItem("email",result.email);
            //token concept implementation 
            localStorage.setItem('access_token', res.data.data.access_token)
            localStorage.setItem('refresh_token', res.data.data.refresh_token)
            localStorage.setItem('device_identifier', res.data.data.device_identifier)
            const currentTime = new Date().getTime();
            localStorage.setItem('lastLoginTime', currentTime);
            if(PMS_ADMIN==result.role_code){
                navigate("/pmsadmindashboard", { state: res.data });
                window.location.reload();
            }
            if(PRINCIPAL_INVESTIGATOR==result.role_code){
              // dispatch(getPiStudies(result.user_id))
              axios1
              .post(base_url + 
                "principal-investigator/get_principal_investigator",
                {
                  "user_id": result.user_id
                })
                .then((res) => {
                 
                  let response = res.data.data
                  if(response.pi_id) { 
                localStorage.setItem('contact_number', response.contact_number)
                localStorage.setItem('pi_id', response.pi_id)
                localStorage.setItem('filteredSubjectList', null)
                  navigate("/pidashboard", { state: response });
                window.location.reload();
                
              }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occured while login", {
          toastId: 100
      })
      });      
            }
            
            if(QUALITY_REVIEWER==result.role_code){
              
              navigate("/qrdashboard", { state: res.data });
              window.location.reload();

            
            }
            if(MEDICAL_REVIEWER==result.role_code){
              
              localStorage.setItem("user_id", result.user_id)
              navigate("/mrdashboard", { state: res.data });
              window.location.reload()
            }
            if(MARKETING_HEAD==result.role_code){
              localStorage.setItem("user_id", result.user_id)
              axios1
              .post(base_url + 
                "marketing-head/get_marketing_head_details_by_user_id",
                {
                  "user_id": result.user_id
                })
                .then((res) => {
                  let response = res.data.data
                  if(response[0].mh_id) { 
                      localStorage.setItem('mh_id', response[0].mh_id)
                      localStorage.setItem('mh_zone_id', response[0].zone_id)
                      navigate("/mhdashboard", { state: res.data });
              window.location.reload()

                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error("Error occured while login", {
                      toastId: 100
                    })
                  });      
              
              
            }

            if(MARKETING_STAFF == result.role_code){
              axios1
              .post(base_url + 
                "marketing-staff/fetch_dropdown_options",
                {
                  "user_id": result.user_id
                })
                .then((res) => {
                  if (localStorage.getItem("role_code") == MARKETING_STAFF) {
                    localStorage.setItem("ms_id", result.user_id)
                  }
                  let response = res.data.data
                    navigate("/marketingstaffdashboard");
              window.location.reload()
                })
                }
            
              }
            }
          })
      .catch((err) => {
        console.log(err);
        toast.error("Error occured while login", {
          toastId: 101
        })
      });
    };
    
    return (
      <div className="bg-image pms_admin_login_main">
    <ForgotPassword modalShow={modalShow} setModalShow={setModalShow} />
      <div className="login_main">
        <div className="login_container">
          <div className="login_form_fields">
            <div className="text-center">
              <img
                className="login_brand_img "
                src="./images/login_brand_logo.svg"
                alt=""
              />
            </div>
            <div className="fields">
              <p className="text-danger d-flex">
                {errorMessage}
              </p>
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="text"
                className="input_data"
                placeholder="Enter Email"
                value={email}
                onChange={handleEmailChange}
              />
            </div>
            <div className="fields ">
              <label htmlFor="password">Password</label>
               <div className="input-with-icon">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  className="input_data"
                  placeholder="Enter Password"
                  value={password}
                  onChange={handlePasswordChange}
                />
                <span className="password-toggle" onClick={togglePasswordVisibility}>
                  {showPassword ? <FaEye/> : <FaEyeSlash />}
                </span>
              </div>
            <p className='forgotPwd_link' onClick={handleForgotPwd}>Forgot Password</p>

            </div>
            <div className="login_checkbox">
                <input
                  className="custom-checkbox"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={termsChecked}
                  onChange={handleTermsCheckedChange}
                />
                {/* <label className=" agree_terms" htmlFor="flexCheckChecked">
                  <span className="">
                    I agree to the &nbsp;<u> Privacy Policy </u>&nbsp; and &nbsp;
                    <u>Terms & Conditions</u>
                  </span>
                </label> */}
              <label className="agree_terms" htmlFor="flexCheckChecked">
                <span>
                  I agree to the&nbsp;
                <Link to="https://www.bharatbiotech.com/privacy-policy.html" target="_blank">
                  Privacy Policy
                </Link>
                &nbsp;and&nbsp;
                <Link to="https://www.bharatbiotech.com/terms-conditions.html" target="_blank">
                Terms & Conditions
                </Link>
                </span>
              </label>

             
              </div>
            <div className="sign_in_main">
              <button
                className={`sign_in ${isSignInEnabled ? "enabled" : ""}`}
                disabled={!isSignInEnabled}
                onClick={handleLogin}
              >
                Sign In
              </button>

              {/* <div className="login_checkbox">
                <input
                  className="custom-checkbox"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={termsChecked}
                  onChange={handleTermsCheckedChange}
                />
                <label className=" agree_terms" htmlFor="flexCheckChecked">
                  <span className="">
                    I agree to the &nbsp;<u> Privacy Policy </u>&nbsp; and &nbsp;
                    <u>Terms & Conditions</u>
                  </span>
                </label>
              </div> */}
            </div>
          </div>
          <div className="login_footer_hr"></div>

          <div className="row login_footer">
            <div className="col ps-0 footer_cntct_dtls">
              <p className="b_txt">+91 9154172282</p>
              <p className="b_txt ">trialtrak.support@turnkeylearning.com</p>
            </div>
          </div>
        </div>
      </div>
        <div className="dBrand ">
        <h5><img src="./images/brand_logo.svg" alt="" /><i>TrialTrak</i><sup><small>TM</small></sup> Turnkey Learning 2023</h5>
        </div>
    </div>
  );
};

export default LoginPage;
